/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { sortableElement } from 'react-sortable-hoc/dist/react-sortable-hoc';

import BuilderViewField from './FormElements/BuilderViewField';
import TextInputElementViews from './FormElements/TextInputElement';

import { FormElementProps } from './types';
import {
  FormElementDefinition, // FormElementType,
} from '../../types/shared/EvaluationForm';

// TODO: Should be { [key: FormElementType]: any }
let formElementsViews: {
  [key: string]: any;
} = {
  TextInputElement: TextInputElementViews,
};

function FormElement(props: FormElementProps<FormElementDefinition>) {
  let { definition, mode } = props;
  let formElementViews = formElementsViews[definition.type];
  let FormElement = formElementViews[mode];
  return <FormElement {...props} />;
}

let SortableFormElement = sortableElement((props: any) => (
  <BuilderViewField {...props}>
    <FormElement {...props} />
  </BuilderViewField>
));

export default function (props: FormElementProps<FormElementDefinition>) {
  let Component = props.mode === 'builder' ? SortableFormElement : FormElement;
  return <Component {...props} />;
}
